import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

interface Props {
  downloadUrl: string | null;
  onClose: () => void;
  message?: string;
  title?: string;
  buttonText?: string;
}

export const DownloadDialog: React.FC<Props> = ({
  downloadUrl,
  onClose,
  message = 'Your download file is ready. Click below to download it:',
  title = 'Download your file',
  buttonText = 'Download file',
}) => {
  return (
    <Dialog open={!!downloadUrl} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
        <a href={downloadUrl} target="_blank" rel="noopener noreferrer">
          {buttonText}
        </a>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
